import { CREATIVE_BASE_FOLDER, CREATIVE_BASE_FOLDER2, INTERNAL_FOLDER_ITEM, INTERNAL_FOLDER_ITEM_DEPTH_1, INTERNAL_FOLDER_ITEM_DEPTH_2, INTERNAL_FOLDER_ITEM_DEPTH_3 } from './creativeDetail';

export const CREATIVE_FOLDERS = [
  CREATIVE_BASE_FOLDER,
  CREATIVE_BASE_FOLDER2,
  INTERNAL_FOLDER_ITEM,
  INTERNAL_FOLDER_ITEM_DEPTH_1,
  INTERNAL_FOLDER_ITEM_DEPTH_2,
  INTERNAL_FOLDER_ITEM_DEPTH_3,
];

export default CREATIVE_FOLDERS;
